var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSbLevel3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 34",
    style: {
      enableBackground: "new 0 0 88 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#061133;}\r\n\t.st2{fill:#DEDEDE;}\r\n\t.st3{fill:#FFFFFF;stroke:#0F1325;stroke-width:0.3424;}\r\n\t.st4{fill:#A6A6A6;}\r\n\t.st5{fill:none;stroke:#0F1325;stroke-width:0.303;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st6{fill:none;stroke:#0F1325;stroke-width:0.2926;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st7{fill:none;stroke:#0F1325;stroke-width:0.31;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st8{fill:none;stroke:#0F1325;stroke-width:0.3065;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st9{enable-background:new    ;}\r\n\t.st10{fill:none;}\r\n\t.st11{fill:#5B3061;}\r\n\t.st12{fill:#F98526;}\r\n\t.st13{fill:#28B6EA;}\r\n\t.st14{fill:#B44784;}\r\n\t.st15{fill:#CA1D2A;}\r\n\t.st16{fill:#86BC44;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,0h57c3.9,0,7,3.1,7,7v20c0,3.9-3.1,7-7,7H7c-3.9,0-7-3.1-7-7V7C0,3.1,3.1,0,7,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81,0H64H7C3.1,0,0,3.1,0,7v20c0,3.9,3.1,7,7,7h57h17c3.9,0,7-3.1,7-7V7C88,3.1,84.9,0,81,0z M7,32.5 c-3,0-5.5-2.5-5.5-5.5V7C1.5,4,4,1.5,7,1.5h57c3,0,5.5,2.5,5.5,5.5v20c0,3-2.5,5.5-5.5,5.5H7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.2,13.9c0,0.9-0.3,1.7-0.8,2.3c-0.5,0.6-1.3,1-2.2,1.2v0.1c1.1,0.1,2,0.5,2.6,1.1s0.9,1.3,0.9,2.3 c0,1.4-0.5,2.4-1.5,3.2s-2.3,1.1-4.1,1.1c-1.6,0-2.9-0.3-4-0.8v-2c0.6,0.3,1.2,0.5,1.9,0.7s1.3,0.2,2,0.2c1.1,0,1.9-0.2,2.5-0.6 s0.8-1,0.8-1.9c0-0.8-0.3-1.3-0.9-1.7s-1.6-0.5-2.9-0.5h-1.2v-1.9h1.3c2.3,0,3.4-0.8,3.4-2.4c0-0.6-0.2-1.1-0.6-1.4 s-1-0.5-1.8-0.5c-0.5,0-1.1,0.1-1.6,0.2s-1.1,0.5-1.8,0.9l-1.1-1.6c1.3-1,2.8-1.4,4.6-1.4c1.4,0,2.6,0.3,3.4,0.9 S21.2,12.8,21.2,13.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3086",
    transform: "translate(-658.125 17.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1740"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689.9,
    y: -8,
    className: "st11",
    width: 18,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1741"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 707.9,
    y: -8,
    className: "st12",
    width: 9,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1742"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 703.9,
    y: 3,
    className: "st13",
    width: 13,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1743"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689.9,
    y: 3,
    className: "st14",
    width: 13,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1744"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689.9,
    y: -3,
    className: "st15",
    width: 9,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1745"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 698.9,
    y: -3,
    className: "st16",
    width: 9,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3052",
    transform: "translate(20767.727 -18665.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_617_00000039824154437798715700000012722735320693407119_",
    transform: "translate(104.181 942.127)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -20183,
    y: 17714,
    className: "st10",
    width: 28.2,
    height: 18.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-20155.5,17732.8h-26.7c-0.4,0-0.8-0.3-0.8-0.8v-17.3c0-0.4,0.3-0.8,0.8-0.8h26.7c0.4,0,0.8,0.3,0.8,0.8 v17.3C-20154.8,17732.5-20155.1,17732.8-20155.5,17732.8z M-20181.5,17731.3h25.2v-15.8h-25.2V17731.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_158_00000167354891211966219130000007160346307639846820_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20078.6,
    y: 18661.7,
    className: "st1",
    width: 18.7,
    height: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_160_00000150084620610476281970000004638756857381958302_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20070,
    y: 18662.4,
    className: "st1",
    width: 1.5,
    height: 6.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_162_00000124149321167326348900000012067425616390738361_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20065.1,
    y: 18668.7,
    className: "st1",
    width: 1.5,
    height: 6.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_159_00000049179329208987431230000012703206950964969881_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20060.8,
    y: 18656.1,
    className: "st1",
    width: 1.5,
    height: 12.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_161_00000099652650571495893540000017537234268115059380_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20065.5,
    y: 18654.9,
    transform: "matrix(2.644747e-03 -1 1 2.644747e-03 -38680.3594 -1445.3334)",
    className: "st1",
    width: 1.5,
    height: 27.7
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSbLevel3);
export default __webpack_public_path__ + "static/media/Icon-SB-Level-3.a4baf81675b0303e23248261fd727faa.svg";
export { ForwardRef as ReactComponent };